module.exports = __webpack_public_path__ + "static/media/p_26_4.52b3baf4.png";